import layout from './reducers/layout';

export const reducers = {
  layout
};
